import { NavigationRoute } from "../shared/enums/navigation-route.enum";
import { LocationWebshopViewModel, ServiceOpenTimeViewModel } from "../shared/models";
import { WebShopMode } from "./IWebShopService";

/** Result of service time validation */
export enum ServiceTimeValidationResult {
  /** Selected time is still valid - no action needed */
  Valid = 'VALID',

  /** Selected time has expired, but other times are available today */
  SelectedTimeExpired = 'SELECTED_TIME_EXPIRED',

  /** Service closed today (no times available), but has available slots on future days */
  ClosedTodayAvailableLater = 'CLOSED_TODAY_AVAILABLE_LATER',

  /** Service completely unavailable - no times on any day */
  CompletelyUnavailable = 'COMPLETELY_UNAVAILABLE',

  /** No time has been selected yet by user */
  NoTimeSelected = 'NO_TIME_SELECTED',

  /** Selected time is fully booked */
  SelectedTimeFullyBooked = "SELECTED_TIME_FULLY_BOOKED"
}

/** Status after time selection dialog - describes user action */
export enum TimeSelectionStatus {
  /** Current time is still valid - no dialog shown */
  Valid = 'VALID',

  /** User selected a new time - time was updated */
  TimeUpdated = 'TIME_UPDATED',

  /** User cancelled the time selection dialog */
  Cancelled = 'CANCELLED',

  /** Service unavailable - no times to select */
  NoTimeToSelect = 'NO_TIME_TO_SELECT',

  /** No time selected yet - caller should handle navigation */
  None = 'NONE'
}

/** Result of time validation process - returned to caller */
export type TimeValidationResult =
  | { status: TimeSelectionStatus.Valid }
  | { status: TimeSelectionStatus.TimeUpdated; time: ServiceOpenTimeViewModel }
  | { status: TimeSelectionStatus.Cancelled }
  | { status: TimeSelectionStatus.NoTimeToSelect }
  | { status: TimeSelectionStatus.None };


/** Configuration for available times dialog */
export interface IAvailableTimesConfig {
  serviceMode: WebShopMode;
  location: LocationWebshopViewModel;
  navigationRoute: NavigationRoute;
  hasValidOrderTimes?: boolean;
  hasValidOrderTimesToday?: boolean;
  showOnlyToday?: boolean;
}

/** Navigation options for dialog handling */
export interface INavigationOptions {
  /** Navigate to home BEFORE showing dialog (e.g., when service completely unavailable) */
  navigateBeforeDialog: boolean;

  /** Navigate AFTER dialog is closed (e.g., user confirmed or cancelled) */
  navigateOnClose: boolean;
}

